import env from '~/server/helpers/env'

import { addressApiUrl } from '~/../__config__/urls.json'

export const sendPrefetch = (address) => {
  const { uprn, udprn } = address
  const method = 'PUT'
  const baseUrl = addressApiUrl.prefetch[env || 'production']
  const url = `${baseUrl}?uprn=${uprn}&udprn=${udprn}`
  fetch(url, { method })
}
